import api from '@/apis/di/budgetKindItemAPI.js';
import { usefilterActionCombo } from './filterActionCombo.js';
import { getCurrentInstance } from 'vue';

// Combo grid Khoản
export const useBudgetSubKindItemComboMultipleGrid = (comboboxDataRemote, comboboxLoadData) => {
  const { proxy } = getCurrentInstance();
  const { extendFilter } = usefilterActionCombo();

  // func call api lấy dữ liệu combo
  const onBudgetSubKindItemComboboxMutipleLoadData = (payload, row, column) => {
    let extend = [
      { Field: 'parent_id', Operator: 'NOT NULL' },
      { Field: 'inactive', Value: false },
    ]; // 2 Là khoản
    payload.sort = 'budget_kind_item_code';
    payload.columns += ',misa_code_id';
    payload.filter = extendFilter(payload.filter, extend);

    comboboxLoadData(payload, api, comboboxDataRemote, column.dataField);
  };

  // config columns combo
  const budgetSubKindItemComboMutipleConfig = {
    data: comboboxDataRemote,
    columns: [
      {
        title: 'Mã khoản',
        dataField: 'budget_kind_item_code',
        width: 100,
        filterOperator: proxy.$ms.constant.FilterOperator.StartsWith,
      },
      {
        title: 'Tên khoản',
        dataField: 'budget_kind_item_name',
        filterOperator: proxy.$ms.constant.FilterOperator.Contains,
        width: 500,
      },
    ],
    displayField: 'budget_kind_item_code',
    valueField: 'budget_kind_item_code',
    queryMode: 'remote',
    dropdownWidth: 600,
    comboboxLoadData: onBudgetSubKindItemComboboxMutipleLoadData,
    modelValueField: 'budget_sub_kind_item_code',
  };

  // Sự kiện load combo trên grid
  return {
    budgetSubKindItemComboMutipleConfig,
    onBudgetSubKindItemComboboxMutipleLoadData, // trả về thêm để dùng chung chả cả combo ko thuộc grid
  };
};
